module.exports = __webpack_public_path__ + "img/quienes-somos-img.0754ffca.png";